'use client';

/* @jsxImportSource react */

import { useIntl } from 'react-intl';
import { Link } from '@packages/modules/src/Link/Link';
import { downloadItemA11yMessages } from '../DownloadItem/messages';

export type Datasheet = {
  url: string;
  name: string;
};

export interface ProductCardV2DatasheetLinkProps {
  datasheet: Datasheet;
  ariaDescribedBy?: string;
  /** Optional - product the datasheet belongs to, named in the link for screen readers. */
  productName?: string;
}

export const ProductCardV2DatasheetLink = ({
  datasheet,
  ariaDescribedBy,
  productName,
}: ProductCardV2DatasheetLinkProps) => {
  const { formatMessage } = useIntl();

  return (
    <Link
      href={datasheet.url}
      openInNewTab
      className="text-size-body-xs text-color-text-dark hover:text-color-grey-dark hyphens-auto underline"
      aria-describedby={ariaDescribedBy}
    >
      {datasheet.name}
      {productName && (
        <span className="sr-only">
          {' '}
          {formatMessage(downloadItemA11yMessages.forProduct, { productName })}
        </span>
      )}
      <span className="sr-only"> {formatMessage(downloadItemA11yMessages.pdfInNewTab)}</span>
    </Link>
  );
};
